<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
        v-if="hasPermission('create cards_topics')"
        :title="`${localization('Cards Topics')}`"
        :text="`${localization('Browse your card topics.')}`"
        :buttonText="`${localization('Create new topic')}`"
        :total="totalCardsTopics"
        @toggleModal="createTopic"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          ref="customTable"
          :count="totalCardsTopics"
          :DataItems="cardsTopics"
          @Refresh="Refresh"
          @reset="filter = {}"
          :filter="filter"
          :title="'topics'"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="CardsTopics"
        >
          <template #columns>
            <!-- <el-table-column prop="id" label="#" width="100"></el-table-column> -->
            <el-table-column
              prop="name"
              :label="`${localization('Name')}`"
              align="left"
              header-align="left"
            >
              <template #default="{ row }">
                <div>
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="`${localization('Description')}`"
              align="left"
              header-align="left"
            >
              <template #default="{ row }">
                <div>
                  {{ row.description }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="actions"
              width="150"
              align="left"
              header-align="left"
            >
            <template slot-scope="scope">
              <div class="td-actions"  >
                <span   >
                  <a
                    v-if="hasPermission('view cards_topics')"
                      v-tooltip.top-center="`${localization('Show')}`"
                      class="btn btn-info btn-link btn-xs"
                      @click="$router.push({ name: localization('Cards Sub Topics'), params: { id: scope.row.id } })"
                    >
                      <i class="fa fa-eye text-dark"></i
                    >
                    </a>
                    <a
                      v-tooltip.top-center="`${localization('Delete')}`"
                      @click="deleteTopic(scope.row.id)"
                    >
                      <img
                        v-if="hasPermission('delete cards_topics')"
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                </span>
              </div>
            </template>
             </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Create Topic Modal -->
    <el-dialog
      @close="resetForm"
      :title="localization('Create new topic')"
      :visible.sync="dialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      :close-on-click-modal="true"
    >
      <div class="custom_modal_header">
        <div class="images">
          <!-- Using a generic icon or the same one if appropriate, or just leaving it for now -->
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ localization("Create new topic") }}
        </h3>
        <p class="description">
          {{ localization("Enter the topic name and description.") }}
        </p>
      </div>
      <el-form
        :rules="rules"
        ref="addTopicForm"
        :model="form"
        @submit.native.prevent
      >
        <el-form-item
          :label="`${localization('Name')}*`"
          prop="name"
        >
          <el-input
            :placeholder="`${localization('Enter topic name')}`"
            v-model="form.name"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="`${localization('Description')}`"
          prop="description"
        >
          <el-input
            type="textarea"
            :placeholder="`${localization('Enter topic description')}`"
            v-model="form.description"
          ></el-input>
        </el-form-item>

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel">
          {{ localization("Create") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "CardsTopicsIndex",
  data() {
    return {
      filter: {},
      dialogVisible: false,
      form: {
        name: "",
        description: ""
      }
    };
  },
  computed: {
    ...mapGetters("topics_card", [
      "cardsTopics",
      "totalCardsTopics",
      "loading",
    ]),
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    Refresh(query) {
      if (query) {
        this.$store.dispatch("topics_card/GetCardsTopics", { query: query });
      } else if (this.$refs.customTable) {
        this.$refs.customTable.Refresh();
      } else {
        this.$store.dispatch("topics_card/GetCardsTopics", { query: {} });
      }
    },
    createTopic() {
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        name: "",
        description: ""
      };
      this.dialogVisible = false;
    },
    submitForm() {
      this.$refs.addTopicForm.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("topics_card/CreateCardsTopic", this.form)
            .then(() => {
              this.resetForm();
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
              });
              this.Refresh();
            })
            .catch(() => {
              // Handle error if needed
            });
        }
      });
    },
    deleteTopic(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("topics_card/DeleteCardsTopic", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    }
  },
  mounted() {
    this.Refresh({});
  },
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

/* Modal Styles reused/adapted from Groups */
.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3%;
  .lci_btn_modal_cancel {
    background-color: #fff;
    color: #667085;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #eaecf0;
    width: calc(97% / 2);
    &.save {
      background-color: #7f56d9;
      color: #fff;
    }
  }
}
</style>

<style scoped>
::v-deep .el-table .cell {
  padding-left: 10px !important;
}
</style>
